import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

import { Page } from '@/components/page'
import { TreeScreen } from '@/features/trees/TreeScreen'

export const Route = createFileRoute('/locations/manage')({ component: ManageLocationsPage })

const schema = z.object({
  name: z.string().trim().min(1, 'Give it a name').max(128),
  comment: z.string(),
  is_full: z.boolean(),
  only_single_part: z.boolean(),
  limit_to_existing_parts: z.boolean(),
})

function ManageLocationsPage() {
  return (
    <Page title="Locations" description="Every place, including drawers not named yet.">
      <TreeScreen
        kind="locations"
        countLabel="lots"
        schema={schema}
        extra={(detail) => (
          <div className="bg-muted/40 flex items-center gap-3 rounded-lg border p-3">
            <span className="text-muted-foreground text-sm">Label code</span>
            <code className="tabular text-base font-medium tracking-widest">
              {String(detail.short_code ?? '')}
            </code>
          </div>
        )}
        fields={[
          { name: 'name', label: 'Name', placeholder: 'Drawer A1' },
          { name: 'comment', label: 'Comment', type: 'textarea' },
          {
            name: 'is_full',
            label: 'Full',
            type: 'checkbox',
            description: 'Refuse new lots here.',
          },
          {
            name: 'only_single_part',
            label: 'One part only',
            type: 'checkbox',
            description: 'At most one distinct part may be stored here.',
          },
          {
            name: 'limit_to_existing_parts',
            label: 'Only parts already here',
            type: 'checkbox',
            description: 'Refuse parts that do not already have a lot in this place.',
          },
        ]}
        emptyValues={{
          name: '',
          comment: '',
          is_full: false,
          only_single_part: false,
          limit_to_existing_parts: false,
        }}
        toValues={(detail) => ({
          name: String(detail.name ?? ''),
          comment: String(detail.comment ?? ''),
          is_full: Boolean(detail.is_full),
          only_single_part: Boolean(detail.only_single_part),
          limit_to_existing_parts: Boolean(detail.limit_to_existing_parts),
        })}
      />
    </Page>
  )
}
